const dateMinMax = () => {
 const SELECTOR_WRAPPER = `.form-minmax`;
 const SELECTOR_TEXTFIELD = `.textfield`;

 const updateMinMax = (target) => {
 const wrap = target.closest(SELECTOR_WRAPPER);

 if (!wrap || !target.matches(`${SELECTOR_WRAPPER} .textfield`)) return;

 const startDateInput = wrap.querySelector(
 `${SELECTOR_TEXTFIELD}:first-of-type`,
 );
 const endDateInput = wrap.querySelector(
 `${SELECTOR_TEXTFIELD}:last-of-type`,
 );

 target === startDateInput && (endDateInput.min = startDateInput.value);
 target === endDateInput && (startDateInput.max = endDateInput.value);
 };

 const handleInput = ({ target }) => {
 updateMinMax(target);
 };

 const applyDateState = () => {
 document
 .querySelectorAll(`${SELECTOR_WRAPPER} ${SELECTOR_TEXTFIELD}[value]`)
 .forEach(updateMinMax);
 };

 const initialize = () => {
 applyDateState();

 document.body.addEventListener(`input`, handleInput);
 };

 initialize();

 dateMinMax.update = applyDateState;

 dateMinMax.cleanup = () => {
 document.body.removeEventListener(`input`, handleInput);
 };
};

export default dateMinMax;
